import { useProcessing } from "@/context/ProcessingContext";
import { MASCOT } from "@/lib/api";

export default function SolangeWidget() {
  const { active, message } = useProcessing();
  if (!active) return null;

  return (
    <div
      data-testid="solange-peeking-mascot"
      className="fixed bottom-0 right-4 sm:right-8 z-[60] flex items-end gap-3 pointer-events-none"
    >
      <div className="solange-peek mb-6 max-w-[240px] rounded-2xl rounded-br-sm bg-white border border-[#e8d8c8] shadow-xl px-4 py-3">
        <div className="text-[11px] font-semibold uppercase tracking-wider text-[#c17f3e] mb-1">
          Solange
        </div>
        <p className="text-sm text-[#2e1e10] leading-snug" data-testid="solange-status-message">
          {message}
        </p>
        <div className="flex gap-1 mt-2">
          <span className="typing-dot h-1.5 w-1.5 rounded-full bg-[#f0791f]" />
          <span className="typing-dot h-1.5 w-1.5 rounded-full bg-[#f0791f]" />
          <span className="typing-dot h-1.5 w-1.5 rounded-full bg-[#f0791f]" />
        </div>
      </div>
      <div className="solange-peek">
        <img
          src={MASCOT.peek}
          alt="Solange espiando"
          className="solange-bob w-28 sm:w-36 h-auto drop-shadow-2xl select-none"
          style={{ transformOrigin: "bottom center" }}
        />
      </div>
    </div>
  );
}
